<template>
  <div>
    <el-form inline :model="searchForm" :loading="searching">
      <el-form-item label="手机号">
        <el-input placeholder="多个可以用逗号分割" v-model="searchForm.phones">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
        </el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="searchForm.names" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
        </el-input>
      </el-form-item>
      <el-form-item label="联系人手机">
        <el-input v-model="searchForm.contactPhones" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
        </el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input v-model="searchForm.contactNames" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(3)" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-button icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
    </el-row>
    <el-table :data="list"
              ref="tableView"
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="400"
              style="margin-top: 1rem"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4 && item.type !== 5"
                       :type="item.typeText"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       v-if="item.type === 4"
      >
        <template slot-scope="scope">
          <el-row style="margin-top: 10px" v-for="(actionItem, actionIndex) in scope.row[item.key]" :key="'btn_' + actionIndex">
            <el-tag size="medium" >
              {{actionItem[item.tagValueKey]}}
            </el-tag>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       fixed="right"
                       v-if="item.type === 3"
                       :type="item.typeText"
      >
        <template slot-scope="scope">
          <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
            {{actionItem.title}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
  </div>
</template>

<script>
import {queryGroupMembers, removeUserToGroup} from './groupApi'
import {operationByPath} from '../employee/employeeApi'

export default {
  name: 'groupMember',
  data () {
    return {
      searchForm: {
        curPage: 1,
        pageSize: 20,
        phones: '',
        groupId: null,
        contactPhones: '',
        contactNames: '',
        names: ''
      },
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: []
    }
  },
  props: {
    groupData: null
  },
  watch: {
    groupData (d) {
      this.searchForm = {
        curPage: 1,
        pageSize: 20,
        phones: '',
        remarks: '',
        groupId: d.customerGroupId,
        contactPhones: '',
        contactNames: '',
        names: ''
      }
      this.search()
      this.list = []
      this.curPage = 1
      this.totalCount = 0
      this.totalPage = 0
      this.pageSize = 20
      this.listKeyMap = []
    }
  },
  created () {
    if (this.groupData) {
      this.searchForm.groupId = this.groupData.customerGroupId
      this.search()
    }
  },
  methods: {
    search () {
      this.searching = true
      queryGroupMembers(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    reset () {
      this.searchForm.phones = ''
      this.searchForm.contacts = ''
      this.searchForm.names = ''
      this.searchForm.contactNames = ''
      this.searchForm.contactPhones = ''
      this.searchForm.remarks = ''
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'phones'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
      this.multipleEditName = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    batchDelete () {
      const items = this.$refs.tableView.selection
      if (items === undefined || items.length === 0) {
        this.$message.error('请选择需要删除的数据')
        return
      }
      const data = {}
      data.groupId = this.groupData.customerGroupId
      data.customerIds = []
      for (let i = 0; i < items.length; i++) {
        const tempItem = items[i]
        const { customerId } = tempItem
        data.customerIds.push(customerId)
      }

      removeUserToGroup(data).then(rsp => {
        const { code } = rsp
        if (code === 0) {
          this.$message.success('删除成功')
          this.search()
        } else {
          const { message } = rsp
          this.$message.error(message)
        }
      }).catch(null)
    },
    replaceText (text, item, encode) {
      const keys = Object.keys(item)
      for (let i = 0; i < keys.length; i++) {
        const tempKey = keys[i]
        const matchText = '{' + tempKey + '}'
        const index = text.indexOf(matchText)
        if (index >= 0) {
          if (encode === true) {
            text = text.replace(matchText, encodeURIComponent(item[tempKey]))
          } else {
            text = text.replace(matchText, item[tempKey])
          }
        }
      }
      return text
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerGroup/groupMember.vue